import React, { useEffect, useState } from 'react';
import useCommonApi from '../../api/useCommonApi';

interface SesionCerradaProps {
    onLoginRedirect?: () => void;
}

const SesionCerrada: React.FC<SesionCerradaProps> = ({ onLoginRedirect }) => {
    const apiSource = useCommonApi();
    const [msjCierreSesion, setParametros] = useState<any>(null);
    
    const getParametros = async () => {
        const result = await apiSource.obtenerAsync<any>('parametro/active');
        return result.find(a => a.nombre === 'mensajeCierreSesion');
    }
    
    useEffect(() => {
        const fetchData = async () => {
            const parametros = await getParametros();
            setParametros(parametros ? parametros.valor : 'Sesión cerrada');
        };
        fetchData();
        localStorage.removeItem("token");
    }, [apiSource]);

    const handleLoginClick = () => {
        if (onLoginRedirect) {
            localStorage.removeItem("SesionCerrada");
            onLoginRedirect();
        } else {
            window.location.href = process.env.REACT_APP_REDIRECT_URL || '/';
        }
    };

    return (
        <div style={{
            backgroundImage: 'url(../../image/T_transito.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '3rem',
                borderRadius: '8px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
                textAlign: 'center',
                minWidth: '300px'
            }}>
                <img
                    src="../../image/almexLogo.png" 
                    alt="Almex"
                    style={{  width: '100%',
                        maxWidth: '50%',
                        height: 'auto',
                        marginBottom: '1.5rem'
                    }}
                />
                <h2 style={{ textAlign: 'center', marginTop: '2rem', marginBottom: '3rem' }}>{msjCierreSesion}</h2>
                <button
                    onClick={handleLoginClick}
                    style={{
                        backgroundColor: '#007236',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '0.75rem 2rem',
                        fontSize: '1rem',
                        cursor: 'pointer',
                    }}
                >
                    Ir a Login
                </button>
            </div>
        </div>
    );
};

export default SesionCerrada;